module.exports = __webpack_public_path__ + "static/media/StarTrek.69a2c58f.png";